import axios from "axios";
import { config } from "../config";

export const couponInstance = axios.create({
  timeout: 60000,
  headers: {
    "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept, x-client-tag, x_token",
    "content-type": "application/json", // 'application/x-www-form-urlencoded;charset=utf-8"',//'application/json',
    "Cache-Control": "max-age=600",
    "x-client-tag":"live_h5",
    // "x-shortname": config.shortname,
  },
});

export class HTTP {
  constructor() {
    this.baseRestUrl =
      process.env.NODE_ENV === "production" ? config.host : "/coupon";
  }

  request(url, data = {}, params = {}, method, header) {
    // let token;
    let headers = header || {};
    try {
      if (localStorage.getItem('x_token')) { 
        headers['x-token'] = localStorage.getItem('x_token')
      }
    } catch {
    }

    if (!method) {
      method = "POST";
    }

    if (url.indexOf("http") == -1 && url.indexOf("//") !== 0) {
      url = this.baseRestUrl + url;
    }
    
    // let traceidT = getNum()
    // let timestampT = new Date().getTime()
    // let tokenT = token
    // let paramsT = JSON.stringify(data)
    // let signT = md5(paramsT + tokenT + timestampT + traceidT)
    // const newParams = {
    //   traceid: traceidT,
    //   timestamp: timestampT,
    //   token: tokenT,
    //   params: data,
    //   sign: signT,
    // }

    return new Promise((resolve, reject) => {
      couponInstance({
        url: url,
        data: data,
        params: {
          ...params,
        },
        method: method,
        headers: headers,
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  get(url, params) {
    return this.request(url, {}, params, "GET");
  }

  post(url, data, params = {}, headers = {}) {
    const obj = data;
    return this.request(url, obj, params, 'POST', headers);
  }

  put(url, data, params = {}) {
    const obj = {
      params: JSON.stringify(data),
    };
    return this.request(url, obj, params, "PUT");
  }
}

//生成32位随机数
function getNum(){  
  let chars = ['0','1','2','3','4','5','6','7','8','9','A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z','a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s','t','u','v','w','x','y','z'];  
  let nums="";  
  for(let i=0; i<32; i++){  
      let id = parseInt(Math.random()*61);  
      nums += chars[id];  
  }  
  return nums;  
}